import React from 'react';
import { Card, Grid } from '@statsbomb/kitbag-components';

import { MyPlaylists } from '@statsbomb/video-client-js';
import {
  BasicPageNoPadding,
  KitbagPageGridHolder,
} from '../../components/Layout/Layout.styles';
import { PAGE } from '../../components/app/index.constants';
import { PlaylistsWrapper } from './Playlists.styles';

const Playlists = () => (
  <BasicPageNoPadding $top={PAGE.DEFAULT.top}>
    <KitbagPageGridHolder>
      <Grid container={false} page>
        <Grid item xs={12}>
          <Card>
            <PlaylistsWrapper>
              <MyPlaylists />
            </PlaylistsWrapper>
          </Card>
        </Grid>
      </Grid>
    </KitbagPageGridHolder>
  </BasicPageNoPadding>
);

export default Playlists;
